import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defineMessages } from 'react-intl';

import Body from '../partials/Body';

import styles from '../../../styles/blocks/text.module.scss';

export const messages = defineMessages({
    exemple: {
        id: 'content.blocks.example',
        defaultMessage: 'Exemple de texte',
    },
});

const propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string,
    }),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    body: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    image: null,
    title: null,
    subtitle: null,
    body: null,
    className: null,
};

const TextBlock = ({ image, title, subtitle, body, className }) => {
    return body || title || subtitle || image ? (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {title ? <h2 className={styles.title}>{title}</h2> : null}
            {image && image.url ? (
                <img className={styles.image} src={image.url} alt="Block" />
            ) : null}
            {subtitle ? <h3 className={styles.subtitle}>{subtitle}</h3> : null}
            {body ? <Body body={body} /> : null}
        </div>
    ) : null;
};

TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;

export default TextBlock;
